module.exports = {
    TargetSelected: "SMARTBONUSDATA.TARGETSELECTED",
};


// WEBPACK FOOTER //
// ./src/actions/metadata/SmartBonusActions.js